import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Alert } from '../components';
import { FaSignInAlt, FaEnvelope, FaLock } from 'react-icons/fa';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // 获取登录成功后的重定向路径，如果没有则默认为仪表盘
  const from = location.state?.from?.pathname || '/dashboard';

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // 表单验证
    if (!email.trim()) {
      return setError('请输入邮箱地址');
    }
    
    if (!password) {
      return setError('请输入密码');
    }
    
    try {
      setError('');
      setLoading(true);
      
      // 调用登录接口
      await login(email, password);
      
      // 登录成功，重定向到之前尝试访问的页面或仪表盘
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.response?.data?.message || '登录失败，请检查您的邮箱和密码');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-8 col-lg-6">
          <div className="card border-0 shadow-sm">
            <div className="card-body p-4 p-md-5">
              <div className="text-center mb-4">
                <h2 className="fw-bold mb-1">欢迎回来</h2>
                <p className="text-muted">登录您的 WebChangeAI 账号</p>
              </div>
              
              {error && (
                <Alert 
                  type="danger"
                  message={error}
                  dismissible={true}
                  onClose={() => setError('')}
                />
              )}
              
              <form onSubmit={handleSubmit}>
                {/* 邮箱输入框 */}
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    邮箱地址
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <FaEnvelope />
                    </span>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder="your.email@example.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      disabled={loading}
                      required
                    />
                  </div>
                </div>
                
                {/* 密码输入框 */}
                <div className="mb-4">
                  <div className="d-flex justify-content-between align-items-center">
                    <label htmlFor="password" className="form-label">
                      密码
                    </label>
                    <Link to="/forgot-password" className="text-decoration-none small">
                      忘记密码?
                    </Link>
                  </div>
                  <div className="input-group">
                    <span className="input-group-text">
                      <FaLock />
                    </span>
                    <input
                      type="password"
                      className="form-control"
                      id="password"
                      placeholder="您的密码"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      disabled={loading}
                      required
                    />
                  </div>
                </div>
                
                {/* 登录按钮 */}
                <div className="d-grid mb-4">
                  <button 
                    type="submit" 
                    className="btn btn-primary py-2"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        登录中...
                      </>
                    ) : (
                      <>
                        <FaSignInAlt className="me-2" />
                        登录
                      </>
                    )}
                  </button>
                </div>
                
                {/* 注册链接 */}
                <div className="text-center">
                  <p className="mb-0">
                    还没有账号? <Link to="/register" className="text-decoration-none">立即注册</Link>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage; 